// extracted by mini-css-extract-plugin
module.exports = {"history_wrapper":"DialogHistory_history_wrapper__FAMFe"};